export default class ItemTypeActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static GET_HELPER_ITEMTYPE='GET_HELPER_ITEMTYPE';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER'
    static RESET_LIST='RESET_LIST'
    
    static submit(){
      return {
        type: ItemTypeActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: ItemTypeActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: ItemTypeActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: ItemTypeActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: ItemTypeActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: ItemTypeActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: ItemTypeActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: ItemTypeActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: ItemTypeActions.PROCESS_DATA,
      };
    }
    static resetList(){
      return {
        type: ItemTypeActions.RESET_LIST,
      };
    }
    static reset(){
      return {
        type: ItemTypeActions.RESET_DATA,
      };
    }
    static helper(data){
      return {
        type: ItemTypeActions.GET_HELPER_ITEMTYPE,
        payload:data
      };
    }
    static errorInternal(data){
      return {
        type: ItemTypeActions.ERROR_SERVER,
        payload:data
      };
    }
  }